import { watchImmediate } from "@vueuse/core";
import { computed, watch } from "vue";
import { useBreakpoints } from "../../../composables/breakpoints";

/**
 * Sets up the col logic (breakpoint class toggles, etc.)
 *
 * @param {import("vue").Ref<HTMLElement>} root - The root element.
 * @returns {void}
 */
export function useCol(root) {
  const host = computed(() => root.value?.getRootNode?.()?.host);

  const { isSmScreen, isMdScreen, isLgScreen } = useBreakpoints();

  const stopHostWatcher = watch(host, () => {
    stopHostWatcher();
    watchImmediate([isSmScreen, isMdScreen, isLgScreen], updateBreakpointClasses);
  });

  function updateBreakpointClasses() {
    host.value.classList.toggle("--is-sm-screen", isSmScreen.value);
    host.value.classList.toggle("--is-md-screen", isMdScreen.value);
    host.value.classList.toggle("--is-lg-screen", isLgScreen.value);
  }
}
